export const INSTITUTIONS = [
    "Alexander College",
    "Arbutus College",
    "Blanche MacDonald",
    "British Columbia Institute of Technology",
    "Capilano University",
    "Canaan College",
    "Canadian College",
    "Columbia College",
    "Coquitlam College",
    "Douglas College",
    "Emily Carr University",
    "Fraser International College",
    "Kwantlen Polytechnic University",
    "Langara College",
    "LaSalle College",
    "Pacific Institution of Culinary Arts",
    "Simon Fraser University",
    "University of British Columbia",
    "University of Canada West",
    "University of Victoria",
    "Vancouver Film School",
    "Vancouver Community College",
    "Vancouver Island University",
    "Vantage College",
    "Other"
]; 